import { createStorage, testStorageSupport } from 'memory-web-storage'

export const storage = testStorageSupport('session') ? window.sessionStorage : createStorage()
